import styled, { css } from 'styled-components';
import { xs } from '@exonet/react-shared/lib/styled';

export const Status = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  color: var(--text);
  align-items: center;

  ${xs(css`
    justify-content: flex-start;
  `)}

  > .react-tooltip {
    z-index: 800;

    ${xs(css`
      display: none;
    `)}
  }

  ${({ action }) =>
    (action.isScheduled() || action.isPending() || action.isRescheduled()) &&
    css`
      font-style: italic;
    `}

  ${({ action }) =>
    action.isRunning() &&
    css`
      font-style: italic;
      color: var(--orange);
    `}

  ${({ action }) =>
    action.isSuccessful() &&
    css`
      color: var(--green);
    `}

  ${({ action }) =>
    (action.isFailed() || action.isUnknown()) &&
    css`
      color: var(--error);
    `}

  > svg {
    min-width: 18px;
    min-height: 18px;
    margin-right: 5px;
    color: currentColor;
  }

  > span {
    display: none;

    ${xs(css`
      display: inline-block;
    `)}
  }
`;
